module.exports = __webpack_public_path__ + "static/media/celso_de_oliveira.f8b0fdd8.jpg";